import { computed } from "vue";
import {
  useStore,
  createNamespacedHelpers,
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from "vuex";

/// STATE TYPES
export type VuexState = VuexRootState & {
  demo: VuexDemoState;
};
export interface VuexRootState {
  count: number;
}
export interface VuexDemoState {
  name: string;
}
/// MUTATION TYPES
export const INCREMENT = "increment";
export const DECREMENT = "decrement";
/// ACTION TYPES
export const INCREMENTACTION = "incrementAction";

export function useVuex() {
  const store = useStore<VuexState>();
  return {
    store
    // state: store.state

    // ...useVuexStates(["count"]),
    // ...useVuexStates("demo", ["name"]),

    // ...useVuexGetters({ totaln: "totaln" }),
    // ...useVuexGetters("demo", ["nameFormat"]),

    // ...useVuexMutations({
    //   [INCREMENT]: INCREMENT,
    //   [DECREMENT]: DECREMENT
    // }),
    // ...useVuexMutations("demo", ["changeName"]),

    // ...useVuexActions({
    //   [INCREMENTACTION]: INCREMENTACTION
    // }),
    // ...useVuexActions("demo", ["changeNameAction"])

    // {{ state.count }}
    // {{ state.demo.name }}
    // {{ store.getters.totalCount }}
    // {{ store.getters.totaln(2) }}
    // {{ totaln(3) }}
    // {{ store.getters["demo/nameFormat"] }}
  };
}

// ...mapState(["count"]);
// ...mapState({ count: state => state.count });
export function useVuexStates(
  keyMaps: Record<string, string> | string[]
): Record<string, any>;
export function useVuexStates(
  moduleName: string,
  keyMaps: Record<string, string> | string[]
): Record<string, any>;
export function useVuexStates(
  moduleName: string | Record<string, string> | string[],
  keyMaps?: Record<string, string> | string[]
): Record<string, any> {
  let mapFn = mapState;
  if (typeof moduleName == "string" && moduleName.length > 0) {
    mapFn = createNamespacedHelpers(moduleName).mapState;
  } else {
    keyMaps = moduleName as Record<string, string> | string[];
  }
  return useVuexMap(keyMaps!, mapFn);
}

// ...mapGetters(["totaln"]);
// ...mapGetters({ totalnAnother: "totaln" });
export function useVuexGetters(
  keyMaps: Record<string, string> | string[]
): Record<string, any>;
export function useVuexGetters(
  moduleName: string,
  keyMaps: Record<string, string> | string[]
): Record<string, any>;
export function useVuexGetters(
  moduleName: string | Record<string, string> | string[],
  keyMaps?: Record<string, string> | string[]
): Record<string, any> {
  let mapFn = mapGetters;
  if (typeof moduleName == "string" && moduleName.length > 0) {
    mapFn = createNamespacedHelpers(moduleName).mapGetters;
  } else {
    keyMaps = moduleName as Record<string, string> | string[];
  }
  return useVuexMap(keyMaps!, mapFn);
}

// ...mapMutations([INCREMENT]);
// ...mapMutations({ inc: INCREMENT });
export function useVuexMutations(
  keyMaps: Record<string, string> | string[]
): Record<string, any>;
export function useVuexMutations(
  moduleName: string,
  keyMaps: Record<string, string> | string[]
): Record<string, any>;
export function useVuexMutations(
  moduleName: string | Record<string, string> | string[],
  keyMaps?: Record<string, string> | string[]
): Record<string, any> {
  let mapFn = mapMutations;
  if (typeof moduleName == "string" && moduleName.length > 0) {
    mapFn = createNamespacedHelpers(moduleName).mapMutations;
  } else {
    keyMaps = moduleName as Record<string, string> | string[];
  }
  if (Array.isArray(keyMaps)) {
    return mapFn(keyMaps!);
  } else {
    return mapFn(keyMaps!);
  }
}

// ...mapActions([INCREMENTACTION]);
// ...mapActions({ inca: INCREMENTACTION });
export function useVuexActions(
  keyMaps: Record<string, string> | string[]
): Record<string, any>;
export function useVuexActions(
  moduleName: string,
  keyMaps: Record<string, string> | string[]
): Record<string, any>;
export function useVuexActions(
  moduleName: string | Record<string, string> | string[],
  keyMaps?: Record<string, string> | string[]
): Record<string, any> {
  let mapFn = mapActions;
  if (typeof moduleName == "string" && moduleName.length > 0) {
    mapFn = createNamespacedHelpers(moduleName).mapActions;
  } else {
    keyMaps = moduleName as Record<string, string> | string[];
  }
  if (Array.isArray(keyMaps)) {
    return mapFn(keyMaps!);
  } else {
    return mapFn(keyMaps!);
  }
}

function useVuexMap(
  keys: Record<string, string> | string[],
  mapFn: any
): Record<string, any> {
  const store = useStore();
  const maps: Record<string, any> = {};
  const mappedKeyFns = mapFn(keys);
  Object.keys(mappedKeyFns).forEach((key) => {
    const fn = mappedKeyFns[key].bind({ $store: store });
    maps[key] = computed(fn);
  });
  return maps;
}
